import Vue from 'vue';

export function getSeekList(data) {
  return Vue.axios({
    url: '/seek/search',
    method: 'post',
    data,
  });
}

export function seekOrder(data) {
  return Vue.axios({
    url: '/seek/orders',
    method: 'post',
    data,
  });
}

export function getBrandList() {
  return Vue.axios({
    url: '/seek/list/brands',
  });
}

export function exportSeekList(data) {
  return Vue.axios({
    url: '/seek/export',
    method: 'post',
    data,
    responseType: 'blob',
  });
}
